module.exports = __webpack_public_path__ + "img/5.c6cf268d.png";